import * as Application from "expo-application";
import { Platform } from "react-native";
import { POST } from ".";
import { storageUtils } from "@/utils/storage";
import { FB_PIXEL_ID } from "@/constants/Configs";
import PostHog from "posthog-react-native";
import StatsigService from "./statsigService";

type UserInfo = {
  email?: string;
  [key: string]: any;
};

const isDevice = Platform.OS !== "web";
class FBTrackingService {
  private static userInfo: UserInfo = {};
  private static posthog = new PostHog(
    "phc_TMRMzkYAUZn888nnZxOdYoH8M7PjpLcexEIM8PSUlDH",
    {
      host: "https://us.i.posthog.com",
    }
  );

  static onInit() {
    this.posthog.ready();
  }

  static setUserInfo(userInfo: UserInfo) {
    FBTrackingService.userInfo = { ...userInfo };
  }
  static setUserId(userId: string) {
    FBTrackingService.userInfo = { ...FBTrackingService.userInfo, userId };
    this.posthog.identify(userId);
    if (isDevice) {
      const appsFlyer = require("react-native-appsflyer").default;
      appsFlyer.setCustomerUserId(userId);
    }

    StatsigService.updateUser(userId);
  }

  static resetUserInfo() {
    FBTrackingService.userInfo = {};
  }

  private static getUserData(extraUserData: any = {}) {
    return {
      ...FBTrackingService.userInfo,
      ...extraUserData,
      platform: Platform.OS,
      userAgent: `Sparrow/${Application.nativeApplicationVersion} (${Platform.OS}; ${Platform.Version})`,
      deviceId: storageUtils.getDeviceId(),
    };
  }

  static trackEvent(
    eventName: string,
    {
      eventData,
      userData = {},
    }: {
      eventData: any;
      userData?: any;
    }
  ) {
    if (!eventName) {
      console.warn("FBTrackingService: eventName is empty, skipping");
      return;
    }
    // if (__DEV__) {
    //   return;
    // }
    const formattedUserData = FBTrackingService.getUserData(userData);
    if (isDevice) {
      const { AppEventsLogger } = require("react-native-fbsdk-next");
      AppEventsLogger.logEvent(eventName, {
        eventData,
        userData: formattedUserData,
      });
      const appsFlyer = require("react-native-appsflyer").default;
      appsFlyer.logEvent(eventName, {
        eventData,
        userData: formattedUserData,
      });
    }

    StatsigService.logEvent(eventName, undefined, {
      eventData,
      userData: formattedUserData,
    });

    this.posthog.capture(eventName, {
      eventData,
      userData: formattedUserData,
    });
    POST("/fb-capi", {
      eventName,
      eventData,
      pixelId: FB_PIXEL_ID,
      userData: formattedUserData,
    });
  }

  static trackAppInstall() {
    if (!isDevice) {
      return;
    }
    return FBTrackingService.trackEvent("AppInstall", {
      eventData: {},
      userData: {},
    });
  }

  static trackAppLaunch() {
    if (!isDevice) {
      return;
    }
    return FBTrackingService.trackEvent("AppLaunch", {
      eventData: {},
      userData: {},
    });
  }

  static trackLead(leadData: any, userData: any = {}) {
    return FBTrackingService.trackEvent("Lead", {
      eventData: leadData,
      userData,
    });
  }

  static trackViewContent(content: string, userData: any = {}) {
    return FBTrackingService.trackEvent("ViewContent", {
      eventData: {
        content,
      },
      userData,
    });
  }

  static trackAddPaymentMethod(paymentMethodData: any, userData: any = {}) {
    return FBTrackingService.trackEvent("AddPaymentMethod", {
      eventData: paymentMethodData,
      userData,
    });
  }

  static trackSignUpWithReferral(eventData: any, userData: any = {}) {
    return FBTrackingService.trackEvent("SignUpWithReferral", {
      eventData,
      userData,
    });
  }

  static trackPurchase(purchaseData: {
    productId: string;
    transactionId: string;
    revenue: number;
    currency: string;
  }) {
    return FBTrackingService.trackEvent("af_purchase", {
      eventData: {
        af_revenue: purchaseData.revenue,
        af_currency: purchaseData.currency,
        af_order_id: purchaseData.transactionId,
        af_content_id: purchaseData.productId,
        af_content_type: "subscription",
      },
    });
  }
}

export default FBTrackingService;
